export const PeriodQueryKeys = {
    all: ['periods'] as const,
    status: (date: string) => [...PeriodQueryKeys.all, 'status', date] as const,
    fiscalYears: () => [...PeriodQueryKeys.all, 'fiscal-years'] as const,
    /** The monthly periods of one fiscal year. */
    list: (fiscalYearId: string) =>
        [...PeriodQueryKeys.all, 'list', fiscalYearId] as const,
    /**
     * Dry run of the year-end close.
     *
     * `locale` is part of the key because it is part of the request — the server
     * resolves account names into it, so two locales are two different
     * responses. There is no `rolloverPreview` sibling: that endpoint does not
     * exist (see `useClosePreviewQueries`).
     */
    closePreview: (fiscalYearId: string, locale?: string) =>
        [
            ...PeriodQueryKeys.all,
            'close-preview',
            fiscalYearId,
            locale ?? '',
        ] as const,
};
